import React from "react";
import cn from "classnames";

import Search from "../Icons/Search";

import styles from "./JobSearchinput.module.scss";

interface JobSearchInputProps {
    searchUrl: string;
    onSearchSubmit?: (keyword: string) => void;
}

const JobSearchInput = (props: JobSearchInputProps & React.HTMLProps<HTMLDivElement>) => {
    const {
        className,
        searchUrl,
        onSearchSubmit
    } = props;

    const [keyword, setKeyword] = React.useState("");

    const onSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        onSearchSubmit?.(keyword);
        if (keyword?.length > 0) {
            window.location.href = `${searchUrl}/keyword/${encodeURI(keyword)}`;
        } else {
            window.location.href = `${searchUrl}`;
        }
    };

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setKeyword(event.target.value);
    };

    const classNames = cn(styles.searchContainer, className);

    return (
        <div className={classNames}>
            <form action={searchUrl} className={styles.form} method="get" role="search" onSubmit={onSubmit}>
                <label className={styles.hidden} htmlFor="search-input">
                    Search
                </label>
                <input
                    id="search-input"
                    aria-label="Search"
                    className={styles.input}
                    type="search"
                    name="keyword"
                    placeholder="Search Jobs"
                    onChange={onChange}
                />
                <button aria-label="Submit Search" className={styles.searchButton} type="submit">
                    <Search className={styles.searchIcon} />
                </button>
            </form>
        </div>
    );
};

export { JobSearchInput as default };
